import { AUTHENTICATION, ANALYTICS_TRACK } from "constants/action-types";
import { LoginActions } from "constants/analytics";
import { EventTypes } from "redux-segment";

export const requestForgotPassword = (payload) => ({
    payload,
    type: AUTHENTICATION.FORGOT_PASSWORD.START,
});

export const resetState = () => ({
    type: AUTHENTICATION.FORGOT_PASSWORD.RESET,
});

export const trackLoginArticles = () => {
    return (dispatch) => {
        dispatch({
            meta: {
                analytics: {
                    eventPayload: {
                        event: LoginActions.LoginArticles,
                    },
                    eventType: EventTypes.track,
                },
            },
            type: ANALYTICS_TRACK,
        });
    };
};

export const trackLoginRegistration = () => {
    return (dispatch) => {
        dispatch({
            meta: {
                analytics: {
                    eventPayload: {
                        event: LoginActions.LoginRegistration,
                    },
                    eventType: EventTypes.track,
                },
            },
            type: ANALYTICS_TRACK,
        });
    };
};

export const trackLoginVideo = () => {
    return (dispatch) => {
        dispatch({
            meta: {
                analytics: {
                    eventPayload: {
                        event: LoginActions.LoginVideo,
                    },
                    eventType: EventTypes.track,
                },
            },
            type: ANALYTICS_TRACK,
        });
    };
};
